import { Box, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import {
    PoolBanner,
    PoolButton,
    PoolFormattedMessage,
    PoolModal,
    PoolModalActions,
    PoolModalContent,
    PoolModalTitle,
    StyledSumTableWrapper,
} from '@synergy/components-next';
import { ReactElement } from 'react';
import { useFormikContext } from 'formik';
import LoadingButton from '@mui/lab/LoadingButton';

import { BonusSettlementDetailFormValues } from '../../models/bonus-settlement-detail-form-values';
import { BonusSettlementDetailSumTable } from './bonus-settlement-detail-sum-table';
import {
    bonusSettlementDetailLoadingSelector,
    bonusSettlementDetailSelector,
} from '../store/bonus-settlements-detail-selector';
import { useAppSelector } from '../../../../store/store';

interface BonusSettlementSubmitModalProps {
    open: boolean;
    onClose: () => void;
}

export const BonusSettlementDetailSubmitModal = (props: BonusSettlementSubmitModalProps): ReactElement => {
    const { open, onClose } = props;
    const formikContext = useFormikContext<BonusSettlementDetailFormValues>();
    const bonusSettlementDetail = useAppSelector(bonusSettlementDetailSelector);
    const loading = useAppSelector(bonusSettlementDetailLoadingSelector);

    return (
        <PoolModal open={open} onClose={onClose}>
            <PoolModalTitle>
                <FormattedMessage id="app.bonusSettlements.supplierDetail.submitModalTitle" />
            </PoolModalTitle>
            <PoolModalContent>
                <Stack gap={2}>
                    <Box>
                        <PoolFormattedMessage
                            id="app.bonusSettlements.supplierDetail.submitModalContent"
                            values={{ year: bonusSettlementDetail?.year }}
                        />
                    </Box>
                    <StyledSumTableWrapper>
                        <BonusSettlementDetailSumTable isModal={true} />
                    </StyledSumTableWrapper>
                    <PoolBanner variant="outlined" sx={{ textAlign: 'left' }}>
                        <FormattedMessage id="app.bonusSettlements.supplierDetail.submitModalBanner" />
                    </PoolBanner>
                </Stack>
            </PoolModalContent>
            <PoolModalActions>
                <PoolButton variant="outlined" onClick={onClose}>
                    <FormattedMessage id="app.common.cancel" />
                </PoolButton>
                <LoadingButton
                    onClick={() => formikContext.submitForm()}
                    loading={loading}
                    variant="contained"
                    loadingPosition="start"
                    sx={{ paddingLeft: loading ? 5 : 2 }}
                >
                    <FormattedMessage id="app.bonusSettlements.supplierDetail.submit" />
                </LoadingButton>
            </PoolModalActions>
        </PoolModal>
    );
};
